export default function IconBtn({children, restProps}){
    return (
        <button className="border-0 p-4 outline-0 flex justify-center items-center" {...restProps} >{children}</button>
    ); 
}